import { useTabContext } from '../context.esm.js';

function useTabStyles(props) {
  var selected = props.selected,
      disabled = props.disabled;

  var _useTabContext = useTabContext(),
      fitted = _useTabContext.fitted;

  var styleProps = {
    margin: '-mb-px',
    borderWidth: ['border-b-2'],
    borderColor: 'border-transparent',
    padding: ['px-4', 'py-3'],
    textColor: ['text-gray-500', 'hover:text-gray-700', 'focus:text-gray-700']
  };

  if (fitted) {
    styleProps.flex = 'flex-1';
  }

  if (selected) {
    styleProps.textColor = 'text-blue-500';
    styleProps.borderColor = 'border-blue-500';
  }

  if (disabled) {
    styleProps.textColor = 'text-gray-400';
    styleProps.cursor = 'cursor-not-allowed';
  }

  return styleProps;
}

export default useTabStyles;
//# sourceMappingURL=styles.esm.js.map
